import { fetchWithErrorHandling, guestPrefix } from './apiUtils';
import { GiftClaim } from '../types';

export class MyGiftsService {
  static async getActiveGiftClaims(): Promise<GiftClaim[]> {
    const response = await fetchWithErrorHandling<{ data: GiftClaim[] }>(
      `/api/v2${guestPrefix()}/users/me/gifts`
    );
    return response.data;
  }
}
